//#region import
import React, { useEffect, useState } from 'react'
import { Grid, IconButton, Popover, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { FnAxios, FnDialog } from 'utilities/utilities';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { BtnAddOnTable } from 'components/Button/ButtonTable';
import { FilterFieldInterface } from 'components/DataGrid/DataGridProps';
import { GetMenuPermission } from 'utilities/SystemFunction';
import InfoIcon from '@mui/icons-material/Info';
;
//#endregion
const BasicInformationList = () => {
    const navigate = useNavigate();
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [loadingTable, setLoadingTable] = useState(false);
    const [sUpdateName, setUpdateName] = useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const handleViewInfo = (e) => {
        setUpdateName(e.sUpdateName);//sUpdateName
    }
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    const dataColumn: any = [
        {
            field: "เพิ่ม/แก้ไข",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            getActions: (item) => {
                return [
                    <BtnAddOnTable
                        IsDisabled={!isPermission}
                        onClick={() => navigate(item.row.sRoute)} id={"Add"} />
                ];
            },
        },
        {
            field: "sName",
            headerName: "ชื่อข้อมูลพื้นฐาน",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            flex: 1,
            width: 220,
        },

        {
            field: "sUpdate",
            headerName: "แก้ไขล่าสุด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            flex: 0.5,
            width: 220,
            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },


    ];

    const getTableDatatype = (p: PaginationInterface) => {
        setLoadingTable(true);
        let Param = {
            ...p,
        };
        AxiosFn.Post(`BasicInformation/GetTableDataType`, Param, (result) => {
            setLoadingTable(false);
            setDataRow({
                ...p,
                arrRows: [...result.lstDataType],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });

        });
    };

    useEffect(() => {
        getTableDatatype(dataRow);
    }, []);

    //Filter Search
    const filter: FilterFieldInterface[] = [
        { sTypeFilterMode: "input", sLabel: "ชื่อข้อมูลพื้นฐาน", sFieldName: "sName", nGridLG: 5, nGridMD: 6, nGridSM: 6, nGridXS: 12 },
       // { sTypeFilterMode: "daterange", sLabel: "วันที่แก้ไขข้อมูล", sFieldName: "lstnUpdate", nGridLG: 6, nGridMD: 6, nGridSM: 4.5, nGridXS: 12,minDate : null,maxDate:null },
        { sTypeFilterMode: "date", sLabel: "วันที่แก้ไขข้อมูล (เริ่มต้น)", sFieldName: "nUpdateStart", nGridLG: 3, nGridMD: 3, nGridSM: 4, nGridXS: 12 },
        { sTypeFilterMode: "date", sLabel: "วันที่แก้ไขข้อมูล (สิ้นสุด)", sFieldName: "nUpdateEnd", nGridLG: 3, nGridMD: 3, nGridSM: 4, nGridXS: 12 },
    ];

    return (
        <React.Fragment>
            <Grid item xs={12} sx={{ mt: 1 }}>
                <DataGrid
                    sTableID='tb1'
                    columns={dataColumn}
                    rows={dataRow}
                    modeFilter={1}
                    onLoadData={getTableDatatype}
                    isLoading={loadingTable}
                    isHiddenToolHead={false}
                    isShowCheckBox={false}
                    filterField={filter}
                />
            </Grid>

            {/* pop over */}
            <Popover
                id={`sUpdateName`}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Typography sx={{ p: 2 }}>{sUpdateName}</Typography>
            </Popover>
        </React.Fragment >
    )
}
export default BasicInformationList;

